import { AutoCompleteDataModel, ChannelAutoCompleteDataModel } from 'components/MprcAutoComplete/AutoCompleteDataModel';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChannelAddMemberAutoComplete } from "./ChannelAddMemberAutoComplete";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    channelId: string;
    onError: (e: any) => void;
    onItemsChange: (members: string[]) => void;
}

////////////////////////////////////////////////////////////////////////////

export const AddChannel: React.FC<IProps> = (props) => {

    const { channelId, onItemsChange, onError } = props;
    const { t } = useTranslation("knowledge");

    const [selectedItem, setSelectedItem] = useState<ChannelAutoCompleteDataModel>();

    ////////////////////////////////////////////////////////////////////////////
    ///
    const onChange = (item: (AutoCompleteDataModel[] | ChannelAutoCompleteDataModel[])) => {
        if (item.length > 0) {
            setSelectedItem(item[0] as ChannelAutoCompleteDataModel);
        } else {
            setSelectedItem(undefined);
        }
    };

    ////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        onItemsChange(selectedItem != undefined ? [selectedItem.usersGroup.id] : []);
    }, [selectedItem]);

    return (
        <ChannelAddMemberAutoComplete
            autoFocus
            onChange={onChange}
            onError={onError}
            multiSelect={false}
            excludeChannelId={channelId}
            selectedItems={selectedItem != undefined ? [selectedItem] : []}
            placeholder={t("Channel.Edit.Members.SelectChannelPlaceholder")}
            helperText={t("Channel.Edit.Members.SelectChannelHint")}
        />
    );
};
